export default {"src":"/_next/static/media/logo-book-ocean.d2ec28f9.svg","height":30,"width":80,"blurWidth":0,"blurHeight":0};